import SavedPersonas from './SavedPersonas';

export default SavedPersonas;
